<div class="modal-header">
  <h2>Copy email template(s)</h2>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<app-copy-template-form
  [accounts]="accounts"
  [templates]="templates"
  (fetchTemplates)="fetchTemplates.emit($event)"
  (copyTemplate)="copyTemplate.emit($event)"
>
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
  >
    Cancel
  </button>
</app-copy-template-form>
